module.exports = __webpack_public_path__ + "static/media/ph_meter.6ce4e925.png";